// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownMenu_container__1Yg5o","option":"DropdownMenu_option__3ILzu"};